import { getMyGroup } from "../auth/AuthGate";
const API_KEY_STORAGE = "debug-api-key";
const COMPANY_TYPES = [
    "service",
    "mechanic",
    "forestry",
    "agriculture",
    "metalworks",
];
const TYPE_LABELS = {
    service: "Dienstleistung",
    mechanic: "Handwerk",
    forestry: "Forstwirtschaft",
    agriculture: "Landwirtschaft",
    metalworks: "Metallverarbeitung",
};
const RANDOM_NAME_ADJECTIVES = [
    "Nordische",
    "Fleißige",
    "Kreative",
    "Solide",
    "Findige",
    "Digitale",
    "Grüne",
    "Schnelle",
    "Traditionelle",
    "Moderne",
];
const RANDOM_NAME_NOUNS = [
    "Schmiede",
    "Manufaktur",
    "Werkstatt",
    "Genossenschaft",
    "Betriebe",
    "Handwerker",
    "Kontor",
    "Werke",
    "Dienste",
    "Kollektiv",
];
function randomCompanyName() {
    const adj = RANDOM_NAME_ADJECTIVES[Math.floor(Math.random() * RANDOM_NAME_ADJECTIVES.length)];
    const noun = RANDOM_NAME_NOUNS[Math.floor(Math.random() * RANDOM_NAME_NOUNS.length)];
    return `${adj} ${noun}`;
}
function apiHeaders(key) {
    return { "Content-Type": "application/json", "X-API-Key": key };
}
async function apiFetch(key, path, opts) {
    return fetch(path, {
        ...opts,
        headers: {
            ...apiHeaders(key),
            ...opts?.headers,
        },
    });
}
export async function mountDebugPanel() {
    const group = await getMyGroup();
    const orgId = group?.id ?? "";
    // ── Shell ──────────────────────────────────────────────────────────────────
    const panel = document.createElement("div");
    panel.style.cssText = [
        "position:fixed",
        "top:0",
        "right:0",
        "bottom:0",
        "z-index:200",
        "display:flex",
        "flex-direction:row",
        "pointer-events:none",
    ].join(";");
    const tab = document.createElement("button");
    tab.textContent = "DEBUG";
    tab.style.cssText = [
        "position:absolute",
        "top:50%",
        "right:0",
        "transform:translateY(-50%) translateX(-100%) rotate(-90deg) translateX(50%)",
        "transform-origin:right center",
        "padding:4px 10px",
        "font-size:11px",
        "font-weight:700",
        "letter-spacing:0.08em",
        "background:#e53935",
        "color:#fff",
        "border:none",
        "border-radius:4px 4px 0 0",
        "pointer-events:auto",
        "z-index:201",
    ].join(";");
    const drawer = document.createElement("div");
    drawer.style.cssText = [
        "width:320px",
        "height:100%",
        "overflow-y:auto",
        "background:rgba(10,11,26,0.97)",
        "border-left:1px solid #e5393555",
        "font-family:ui-sans-serif,system-ui,sans-serif",
        "color:#e0dce8",
        "font-size:12px",
        "padding:12px",
        "box-sizing:border-box",
        "pointer-events:auto",
        "display:none",
    ].join(";");
    let open = false;
    tab.addEventListener("click", () => {
        open = !open;
        drawer.style.display = open ? "block" : "none";
    });
    panel.appendChild(tab);
    panel.appendChild(drawer);
    document.body.appendChild(panel);
    // ── Header ─────────────────────────────────────────────────────────────────
    const h1 = document.createElement("div");
    h1.style.cssText =
        "font-size:13px;font-weight:700;color:#e53935;margin-bottom:12px;letter-spacing:0.05em;";
    h1.textContent = "⚙ DEBUG PANEL";
    drawer.appendChild(h1);
    // ── API key ────────────────────────────────────────────────────────────────
    const keySection = section(drawer, "API Key");
    const keyHint = document.createElement("div");
    keyHint.style.cssText = "color:#6a667e;margin-bottom:6px;font-size:11px;";
    keyHint.textContent = "Schlüssel aus dem Sysadmin-Dashboard einfügen.";
    keySection.appendChild(keyHint);
    const keyInput = inputEl("password", "X-API-Key …");
    keyInput.value = localStorage.getItem(API_KEY_STORAGE) ?? "";
    keyInput.addEventListener("input", () => localStorage.setItem(API_KEY_STORAGE, keyInput.value.trim()));
    keySection.appendChild(keyInput);
    const keyError = errorEl();
    keySection.appendChild(keyError);
    // ── Create form ────────────────────────────────────────────────────────────
    const createSection = section(drawer, "Betrieb erstellen");
    const userSelect = document.createElement("select");
    styleSelect(userSelect);
    userSelect.innerHTML = '<option value="">— Nutzer laden …</option>';
    createSection.appendChild(labelEl("Nutzer"));
    createSection.appendChild(userSelect);
    createSection.appendChild(labelEl("Titel"));
    const titleInput = inputEl("text", "Firmenname (leer = zufällig)");
    createSection.appendChild(titleInput);
    createSection.appendChild(labelEl("Beschreibung"));
    const descInput = document.createElement("textarea");
    descInput.placeholder = "Kurzbeschreibung (optional)";
    descInput.rows = 2;
    descInput.style.cssText = inputStyle() + "resize:vertical;height:auto;";
    createSection.appendChild(descInput);
    createSection.appendChild(labelEl("Link-URL"));
    const linkInput = inputEl("text", "https://…");
    createSection.appendChild(linkInput);
    createSection.appendChild(labelEl("Typ"));
    const typeSelect = document.createElement("select");
    styleSelect(typeSelect);
    for (const t of COMPANY_TYPES) {
        const opt = document.createElement("option");
        opt.value = t;
        opt.textContent = TYPE_LABELS[t];
        typeSelect.appendChild(opt);
    }
    createSection.appendChild(typeSelect);
    const createBtn = btnEl("Betrieb erstellen", "#2e7d32");
    createSection.appendChild(createBtn);
    const createStatus = statusEl();
    createSection.appendChild(createStatus);
    // ── Building list ──────────────────────────────────────────────────────────
    const listSection = section(drawer, "Betriebe in dieser Gruppe");
    const deleteAllBtn = btnEl("Alle Betriebe löschen", "#b71c1c");
    listSection.appendChild(deleteAllBtn);
    const listContainer = document.createElement("div");
    listSection.appendChild(listContainer);
    const listError = errorEl();
    listSection.appendChild(listError);
    // ── Logic ──────────────────────────────────────────────────────────────────
    async function loadUsers() {
        const key = localStorage.getItem(API_KEY_STORAGE) ?? "";
        if (!key || !orgId)
            return;
        try {
            const res = await apiFetch(key, `/api/v1/users?organizationId=${encodeURIComponent(orgId)}`);
            if (!res.ok) {
                const body = (await res.json());
                keyError.textContent = `Fehler beim Laden der Nutzer: ${body.error ?? res.status}`;
                keyError.style.display = "block";
                return;
            }
            keyError.style.display = "none";
            const data = (await res.json());
            userSelect.innerHTML = "";
            for (const u of data.users) {
                const opt = document.createElement("option");
                opt.value = u.id;
                opt.textContent = u.name;
                userSelect.appendChild(opt);
            }
        }
        catch {
            keyError.textContent = "Netzwerkfehler beim Laden der Nutzer";
            keyError.style.display = "block";
        }
    }
    async function loadBuildings() {
        const key = localStorage.getItem(API_KEY_STORAGE) ?? "";
        if (!key || !orgId)
            return;
        listError.style.display = "none";
        listContainer.innerHTML = "";
        try {
            const res = await apiFetch(key, `/api/v1/companies?organizationId=${encodeURIComponent(orgId)}`);
            if (!res.ok) {
                const body = (await res.json());
                listError.textContent = body.error ?? `Fehler ${res.status}`;
                listError.style.display = "block";
                return;
            }
            const data = (await res.json());
            if (data.companies.length === 0) {
                const empty = document.createElement("div");
                empty.style.cssText = "color:#6a667e;font-size:11px;";
                empty.textContent = "Keine Betriebe vorhanden.";
                listContainer.appendChild(empty);
                return;
            }
            for (const co of data.companies) {
                const row = document.createElement("div");
                row.style.cssText = [
                    "display:flex",
                    "align-items:center",
                    "justify-content:space-between",
                    "padding:5px 0",
                    "border-bottom:1px solid #ffffff11",
                ].join(";");
                const info = document.createElement("div");
                info.style.cssText = "flex:1;min-width:0;";
                const nameEl = document.createElement("div");
                nameEl.style.cssText =
                    "font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;";
                nameEl.textContent = co.title;
                const metaEl = document.createElement("div");
                metaEl.style.cssText = "color:#6a667e;font-size:10px;";
                metaEl.textContent = `${TYPE_LABELS[co.companyType] ?? co.companyType} · (${co.tileX},${co.tileY})`;
                info.appendChild(nameEl);
                info.appendChild(metaEl);
                const delBtn = btnEl("Löschen", "#b71c1c");
                delBtn.style.cssText +=
                    "padding:3px 8px;font-size:11px;margin-left:8px;flex-shrink:0;";
                delBtn.addEventListener("click", async () => {
                    const k = localStorage.getItem(API_KEY_STORAGE) ?? "";
                    if (!k)
                        return;
                    delBtn.disabled = true;
                    delBtn.textContent = "…";
                    try {
                        const r = await apiFetch(k, `/api/v1/companies/${co.id}`, {
                            method: "DELETE",
                        });
                        if (!r.ok) {
                            const b = (await r.json());
                            listError.textContent = b.error ?? `Fehler ${r.status}`;
                            listError.style.display = "block";
                        }
                    }
                    catch {
                        listError.textContent = "Netzwerkfehler beim Löschen";
                        listError.style.display = "block";
                    }
                    await loadBuildings();
                });
                row.appendChild(info);
                row.appendChild(delBtn);
                listContainer.appendChild(row);
            }
        }
        catch {
            listError.textContent = "Netzwerkfehler beim Laden";
            listError.style.display = "block";
        }
    }
    const DELETE_ALL_LABEL = "Alle Betriebe löschen";
    let deleteAllArmed = false;
    let deleteAllArmTimer = null;
    deleteAllBtn.addEventListener("click", async () => {
        const key = localStorage.getItem(API_KEY_STORAGE) ?? "";
        if (!key || !orgId)
            return;
        // Two-click confirm (no native confirm()): first click arms the button and reverts itself
        // after 4s if not followed up; second click while armed actually deletes.
        if (!deleteAllArmed) {
            deleteAllArmed = true;
            deleteAllBtn.textContent = "Wirklich? Nochmal klicken zum Löschen";
            deleteAllArmTimer = setTimeout(() => {
                deleteAllArmed = false;
                deleteAllBtn.textContent = DELETE_ALL_LABEL;
            }, 4000);
            return;
        }
        if (deleteAllArmTimer)
            clearTimeout(deleteAllArmTimer);
        deleteAllArmed = false;
        deleteAllBtn.textContent = DELETE_ALL_LABEL;
        deleteAllBtn.disabled = true;
        listError.style.display = "none";
        try {
            const res = await apiFetch(key, `/api/v1/companies?organizationId=${encodeURIComponent(orgId)}`);
            if (!res.ok) {
                const body = (await res.json());
                listError.textContent = body.error ?? `Fehler ${res.status}`;
                listError.style.display = "block";
                return;
            }
            const data = (await res.json());
            for (const co of data.companies) {
                const r = await apiFetch(key, `/api/v1/companies/${co.id}`, {
                    method: "DELETE",
                });
                if (!r.ok) {
                    const b = (await r.json());
                    listError.textContent = b.error ?? `Fehler ${r.status}`;
                    listError.style.display = "block";
                }
            }
        }
        catch {
            listError.textContent = "Netzwerkfehler beim Löschen";
            listError.style.display = "block";
        }
        deleteAllBtn.disabled = false;
        await loadBuildings();
    });
    createBtn.addEventListener("click", async () => {
        const key = localStorage.getItem(API_KEY_STORAGE) ?? "";
        if (!key) {
            createStatus.textContent = "Kein API-Key gesetzt.";
            createStatus.style.color = "#e53935";
            createStatus.style.display = "block";
            return;
        }
        if (!userSelect.value) {
            createStatus.textContent = "Bitte Nutzer wählen.";
            createStatus.style.color = "#e53935";
            createStatus.style.display = "block";
            return;
        }
        const title = titleInput.value.trim() || randomCompanyName();
        createBtn.disabled = true;
        createStatus.textContent = "…";
        createStatus.style.color = "#9a96b0";
        createStatus.style.display = "block";
        try {
            const res = await apiFetch(key, "/api/v1/companies", {
                method: "POST",
                body: JSON.stringify({
                    id: crypto.randomUUID(),
                    userId: userSelect.value,
                    title,
                    description: descInput.value.trim(),
                    linkUrl: linkInput.value.trim(),
                    companyType: typeSelect.value,
                }),
            });
            if (res.status === 401) {
                const body = (await res.json());
                createStatus.textContent = `401: ${body.error ?? "Ungültiger API-Key"}`;
                createStatus.style.color = "#e53935";
            }
            else if (!res.ok) {
                const body = (await res.json());
                createStatus.textContent = body.error ?? `Fehler ${res.status}`;
                createStatus.style.color = "#e53935";
            }
            else {
                const data = (await res.json());
                createStatus.textContent = `Erstellt auf (${data.company.tileX},${data.company.tileY})`;
                createStatus.style.color = "#4caf50";
                titleInput.value = "";
                descInput.value = "";
                await loadBuildings();
            }
        }
        catch {
            createStatus.textContent = "Netzwerkfehler";
            createStatus.style.color = "#e53935";
        }
        createBtn.disabled = false;
    });
    // Load users when key changes or panel opens
    keyInput.addEventListener("change", () => {
        void loadUsers();
        void loadBuildings();
    });
    tab.addEventListener("click", () => {
        if (open) {
            void loadUsers();
            void loadBuildings();
        }
    });
    if (keyInput.value) {
        void loadUsers();
        void loadBuildings();
    }
}
// ── DOM helpers ────────────────────────────────────────────────────────────────
function section(parent, title) {
    const s = document.createElement("div");
    s.style.cssText =
        "margin-bottom:16px;border-top:1px solid #ffffff22;padding-top:12px;";
    const h = document.createElement("div");
    h.style.cssText =
        "font-size:11px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;color:#9a96b0;margin-bottom:8px;";
    h.textContent = title;
    s.appendChild(h);
    parent.appendChild(s);
    return s;
}
function inputStyle() {
    return ([
        "width:100%",
        "box-sizing:border-box",
        "background:#1a1a2e",
        "border:1px solid #ffffff33",
        "border-radius:4px",
        "color:#e0dce8",
        "padding:5px 8px",
        "font-size:12px",
        "margin-bottom:6px",
        "display:block",
    ].join(";") + ";");
}
function inputEl(type, placeholder) {
    const el = document.createElement("input");
    el.type = type;
    el.placeholder = placeholder;
    el.style.cssText = inputStyle();
    return el;
}
function labelEl(text) {
    const el = document.createElement("div");
    el.style.cssText =
        "color:#9a96b0;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:3px;margin-top:4px;";
    el.textContent = text;
    return el;
}
function styleSelect(el) {
    el.style.cssText = inputStyle();
}
function btnEl(text, bg) {
    const el = document.createElement("button");
    el.textContent = text;
    el.style.cssText = [
        `background:${bg}`,
        "color:#fff",
        "border:none",
        "border-radius:4px",
        "padding:5px 12px",
        "font-size:12px",
        "margin-top:4px",
        "width:100%",
    ].join(";");
    return el;
}
function errorEl() {
    const el = document.createElement("div");
    el.style.cssText = "color:#e53935;font-size:11px;margin-top:4px;display:none;";
    return el;
}
function statusEl() {
    const el = document.createElement("div");
    el.style.cssText = "font-size:11px;margin-top:4px;display:none;";
    return el;
}
